__turbopack_context__.v({
  "wrapper": "tez50W_wrapper",
});
